import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-bbe78fea"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "marcas-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "marcas-content" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Gestión de Equivalentes", -1 /* HOISTED */));
const _hoisted_6 = { class: "header-top-controls" };
const _hoisted_7 = { class: "search-container" };
const _hoisted_8 = { class: "search-wrapper" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Generar Reporte", -1 /* HOISTED */));
const _hoisted_10 = { class: "filter-controls" };
const _hoisted_11 = { class: "alphabet-filter" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "dropdown-filters" };
const _hoisted_14 = { class: "filter-group autocomplete" };
const _hoisted_15 = {
    key: 0,
    class: "autocomplete-list filter-autocomplete"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("em", null, "Todos los Departamentos", -1 /* HOISTED */));
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = ["onMousedown", "innerHTML"];
const _hoisted_19 = ["disabled"];
const _hoisted_20 = {
    key: 0,
    class: "autocomplete-list filter-autocomplete"
};
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("em", null, "Todas las Categorías", -1 /* HOISTED */));
const _hoisted_22 = [
    _hoisted_21
];
const _hoisted_23 = ["onMousedown", "innerHTML"];
const _hoisted_24 = { class: "table-container" };
const _hoisted_25 = { class: "marcas-table" };
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Repuesto"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Código Equivalente"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Stock Exp."),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Stock Plus"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Stock Mega"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Total"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_27 = { key: 0 };
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "7",
    class: "text-center py-4"
}, "Cargando equivalentes...", -1 /* HOISTED */));
const _hoisted_29 = [
    _hoisted_28
];
const _hoisted_30 = { key: 1 };
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "7",
    class: "text-center py-4 text-muted"
}, "No se encontraron equivalentes.", -1 /* HOISTED */));
const _hoisted_32 = [
    _hoisted_31
];
const _hoisted_33 = { style: { "font-weight": "600" } };
const _hoisted_34 = { class: "d-flex align-items-center" };
const _hoisted_35 = { class: "text-center" };
const _hoisted_36 = { class: "code-and-badge text-center" };
const _hoisted_37 = { class: "stock-stepper" };
const _hoisted_38 = ["onClick", "disabled"];
const _hoisted_39 = ["value", "onChange"];
const _hoisted_40 = ["onClick", "disabled"];
const _hoisted_41 = { class: "stock-stepper" };
const _hoisted_42 = ["onClick", "disabled"];
const _hoisted_43 = ["value", "onChange"];
const _hoisted_44 = ["onClick", "disabled"];
const _hoisted_45 = { class: "stock-stepper" };
const _hoisted_46 = ["onClick", "disabled"];
const _hoisted_47 = ["value", "onChange"];
const _hoisted_48 = ["onClick", "disabled"];
const _hoisted_49 = { class: "text-center" };
const _hoisted_50 = { class: "actions-wrapper" };
const _hoisted_51 = ["onClick"];
const _hoisted_52 = { class: "gallery-icon-container" };
const _hoisted_53 = {
    key: 0,
    class: "dot-badge img-dot"
};
const _hoisted_54 = {
    key: 1,
    class: "dot-badge vid-dot"
};
const _hoisted_55 = ["onClick"];
const _hoisted_56 = { class: "pagination-controls" };
const _hoisted_57 = ["disabled"];
const _hoisted_58 = ["disabled"];
const _hoisted_59 = { class: "total-count-display" };
const _hoisted_60 = { class: "lightbox-window" };
const _hoisted_61 = { class: "lightbox-content" };
const _hoisted_62 = ["src"];
const _hoisted_63 = ["src"];
const _hoisted_64 = {
    key: 1,
    class: "lightbox-empty"
};
const _hoisted_65 = { class: "lightbox-tabs" };
const _hoisted_66 = { class: "tab-count" };
const _hoisted_67 = { class: "tab-count" };
const _hoisted_68 = {
    key: 2,
    class: "lightbox-dots"
};
const _hoisted_69 = ["onClick"];
const _hoisted_70 = {
    key: 3,
    class: "lightbox-counter"
};
const _hoisted_71 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_72 = { class: "modal-window" };
const _hoisted_73 = { class: "modal-header" };
const _hoisted_74 = { class: "modal-title-group" };
const _hoisted_75 = { class: "icon-bg" };
const _hoisted_76 = { class: "modal-title" };
const _hoisted_77 = { class: "form-group premium-input" };
const _hoisted_78 = {
    key: 0,
    class: "base-code-badge",
    title: "Código base de este grupo"
};
const _hoisted_79 = { class: "autocomplete" };
const _hoisted_80 = ["disabled"];
const _hoisted_81 = {
    key: 0,
    class: "autocomplete-list"
};
const _hoisted_82 = ["onClick", "innerHTML"];
const _hoisted_83 = { class: "bulk-items-container" };
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "bulk-header" }, [
    /*#__PURE__*/ _createElementVNode("label", null, "Modelos y Códigos")
], -1 /* HOISTED */));
const _hoisted_85 = { class: "items-list-container" };
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "list-labels-row d-none d-md-flex" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "label-col-codigo" }, "Código"),
    /*#__PURE__*/ _createElementVNode("div", { class: "label-col-stock" }, "Expless"),
    /*#__PURE__*/ _createElementVNode("div", { class: "label-col-stock" }, "Plus"),
    /*#__PURE__*/ _createElementVNode("div", { class: "label-col-stock" }, "Mega"),
    /*#__PURE__*/ _createElementVNode("div", { class: "label-col-stock text-primary fw-bold" }, "Total"),
    /*#__PURE__*/ _createElementVNode("div", { class: "label-col-action" })
], -1 /* HOISTED */));
const _hoisted_87 = { class: "items-list" };
const _hoisted_88 = { class: "row gx-2 gy-2 align-items-center" };
const _hoisted_89 = { class: "col-md-3 col-12" };
const _hoisted_90 = { class: "compact-input-group" };
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "compact-label d-md-none" }, "Código", -1 /* HOISTED */));
const _hoisted_92 = ["onUpdate:modelValue"];
const _hoisted_93 = { class: "col-md-2 col-4" };
const _hoisted_94 = { class: "compact-input-group" };
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "compact-label d-md-none text-center" }, "Exp.", -1 /* HOISTED */));
const _hoisted_96 = ["onUpdate:modelValue"];
const _hoisted_97 = { class: "col-md-2 col-4" };
const _hoisted_98 = { class: "compact-input-group" };
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "compact-label d-md-none text-center" }, "Plus", -1 /* HOISTED */));
const _hoisted_100 = ["onUpdate:modelValue"];
const _hoisted_101 = { class: "col-md-2 col-4" };
const _hoisted_102 = { class: "compact-input-group" };
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "compact-label d-md-none text-center" }, "Mega", -1 /* HOISTED */));
const _hoisted_104 = ["onUpdate:modelValue"];
const _hoisted_105 = { class: "col-md-2 d-none d-md-block" };
const _hoisted_106 = { class: "compact-input-group" };
const _hoisted_107 = ["value"];
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-md-1 col-12 text-end" }, [
    /*#__PURE__*/ _createCommentVNode("\n                                                        <button v-if=\"!item.esReplica && form.items.length > 1\" @click=\"removeItem(Number(index))\" \n                                                            class=\"btn-remove-compact\" title=\"Eliminar fila\">\n                                                            <Trash2Icon :size=\"16\" />\n                                                        </button>\n                                                        ")
], -1 /* HOISTED */));
const _hoisted_109 = {
    key: 0,
    class: "media-section"
};
const _hoisted_110 = { class: "media-header" };
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { style: { "margin": "0" } }, "Multimedia (Máx. 6 fotos, 1 video)", -1 /* HOISTED */));
const _hoisted_112 = { class: "media-grids" };
const _hoisted_113 = { class: "images-grid" };
const _hoisted_114 = ["src"];
const _hoisted_115 = ["onClick"];
const _hoisted_116 = {
    key: 0,
    class: "media-add images-add",
    title: "Elegir de galería"
};
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Galería", -1 /* HOISTED */));
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Cámara", -1 /* HOISTED */));
const _hoisted_119 = { class: "video-grid" };
const _hoisted_120 = {
    key: 0,
    class: "media-preview video-preview"
};
const _hoisted_121 = ["src"];
const _hoisted_122 = {
    class: "media-add video-add",
    title: "Elegir video de galería"
};
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Galería", -1 /* HOISTED */));
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Grabar", -1 /* HOISTED */));
const _hoisted_125 = { class: "modal-footer" };
const _hoisted_126 = ["disabled"];
const _hoisted_127 = {
    key: 0,
    class: "ia-processing-overlay"
};
const _hoisted_128 = { class: "ia-processing-card" };
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", null, "Procesando con IA", -1 /* HOISTED */));
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Extrayendo el repuesto, por favor espera...", -1 /* HOISTED */));
const _hoisted_131 = {
    key: 0,
    class: "camera-overlay"
};
const _hoisted_132 = { class: "camera-window" };
const _hoisted_133 = { class: "camera-header" };
const _hoisted_134 = { class: "camera-title" };
const _hoisted_135 = { class: "camera-header-actions" };
const _hoisted_136 = { class: "camera-body" };
const _hoisted_137 = {
    ref: "cameraVideo",
    class: "camera-preview",
    autoplay: "",
    muted: "",
    playsinline: ""
};
const _hoisted_138 = {
    ref: "cameraCanvas",
    style: { "display": "none" }
};
const _hoisted_139 = {
    key: 0,
    class: "rec-indicator"
};
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "rec-dot" }, null, -1 /* HOISTED */));
const _hoisted_141 = { class: "camera-footer" };
const _hoisted_142 = {
    key: 0,
    style: { "display": "flex", "flex-direction": "column", "align-items": "center", "gap": "10px", "width": "100%" }
};
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "rec-dot-btn" }, null, -1 /* HOISTED */));
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "stop-icon" }, null, -1 /* HOISTED */));
const _hoisted_145 = { class: "modal-window export-modal premium-modal" };
const _hoisted_146 = { class: "modal-header" };
const _hoisted_147 = { class: "modal-title-group" };
const _hoisted_148 = { class: "icon-bg excel-bg" };
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title" }, "Generar Reporte"),
    /*#__PURE__*/ _createElementVNode("p", { class: "modal-subtitle" }, "Seleccione los parámetros del reporte")
], -1 /* HOISTED */));
const _hoisted_150 = { class: "modal-body" };
const _hoisted_151 = { class: "export-info-card" };
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Seleccione los filtros y columnas para su reporte. Los términos de búsqueda actuales se mantendrán en el archivo generado.", -1 /* HOISTED */));
const _hoisted_153 = { class: "export-section" };
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Formato de Salida", -1 /* HOISTED */));
const _hoisted_155 = { class: "export-format-grid" };
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "export-format-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-name" }, "Excel (.xlsx)"),
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-desc" }, "Hoja de cálculo editable")
], -1 /* HOISTED */));
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "export-format-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-name" }, "PDF (.pdf)"),
    /*#__PURE__*/ _createElementVNode("span", { class: "export-format-desc" }, "Documento listo para imprimir")
], -1 /* HOISTED */));
const _hoisted_158 = {
    class: "export-section",
    style: { "margin-top": "24px" }
};
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Filtro de Contenido", -1 /* HOISTED */));
const _hoisted_160 = { class: "filter-type-grid" };
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "filter-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "filter-name" }, "Originales"),
    /*#__PURE__*/ _createElementVNode("span", { class: "filter-desc" }, "Solo productos base")
], -1 /* HOISTED */));
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "filter-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "filter-name" }, "Réplicas"),
    /*#__PURE__*/ _createElementVNode("span", { class: "filter-desc" }, "Solo variaciones")
], -1 /* HOISTED */));
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "filter-card-content" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "filter-name" }, "Todos"),
    /*#__PURE__*/ _createElementVNode("span", { class: "filter-desc" }, "Reporte completo")
], -1 /* HOISTED */));
const _hoisted_164 = {
    class: "export-section",
    style: { "margin-top": "24px" }
};
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Ordenar Por", -1 /* HOISTED */));
const _hoisted_166 = {
    class: "export-format-grid",
    style: { "grid-template-columns": "2fr 1fr", "gap": "10px" }
};
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Repuesto" }, "Repuesto", -1 /* HOISTED */));
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Código Equivalente" }, "Código Equivalente", -1 /* HOISTED */));
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Stock Exp." }, "Stock Exp.", -1 /* HOISTED */));
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Stock Plus" }, "Stock Plus", -1 /* HOISTED */));
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Stock Mega" }, "Stock Mega", -1 /* HOISTED */));
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "Tipo" }, "Tipo (Original/Réplica)", -1 /* HOISTED */));
const _hoisted_173 = [
    _hoisted_167,
    _hoisted_168,
    _hoisted_169,
    _hoisted_170,
    _hoisted_171,
    _hoisted_172
];
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "asc" }, "Ascendente", -1 /* HOISTED */));
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "desc" }, "Descendente", -1 /* HOISTED */));
const _hoisted_176 = [
    _hoisted_174,
    _hoisted_175
];
const _hoisted_177 = {
    class: "export-section",
    style: { "margin-top": "24px" }
};
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-label" }, "Columnas a Incluir", -1 /* HOISTED */));
const _hoisted_179 = { class: "columns-selection-grid" };
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "column-selection-header" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "header-order" }, "#"),
    /*#__PURE__*/ _createElementVNode("span", { class: "header-name" }, "Columna")
], -1 /* HOISTED */));
const _hoisted_181 = { class: "column-order-badge" };
const _hoisted_182 = {
    class: "drag-handle",
    title: "Arrastrar para reordenar"
};
const _hoisted_183 = { class: "checkbox-wrapper" };
const _hoisted_184 = ["value"];
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "checkmark" }, null, -1 /* HOISTED */));
const _hoisted_186 = { class: "column-details" };
const _hoisted_187 = { class: "column-name" };
const _hoisted_188 = { class: "modal-footer" };
const _hoisted_189 = ["disabled"];
const _hoisted_190 = { key: 0 };
const _hoisted_191 = {
    key: 1,
    class: "btn-content"
};
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Generar Reporte", -1 /* HOISTED */));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_FileTextIcon = _resolveComponent("FileTextIcon");
    const _component_LayersIcon = _resolveComponent("LayersIcon");
    const _component_GridIcon = _resolveComponent("GridIcon");
    const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon");
    const _component_ChevronUpIcon = _resolveComponent("ChevronUpIcon");
    const _component_ImageIcon = _resolveComponent("ImageIcon");
    const _component_EditIcon = _resolveComponent("EditIcon");
    const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon");
    const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_VideoIcon = _resolveComponent("VideoIcon");
    const _component_PlusIcon = _resolveComponent("PlusIcon");
    const _component_Wand2Icon = _resolveComponent("Wand2Icon");
    const _component_CameraIcon = _resolveComponent("CameraIcon");
    const _component_Loader2Icon = _resolveComponent("Loader2Icon");
    const _component_RepeatIcon = _resolveComponent("RepeatIcon");
    const _component_DownloadIcon = _resolveComponent("DownloadIcon");
    const _component_InfoIcon = _resolveComponent("InfoIcon");
    const _component_GripVerticalIcon = _resolveComponent("GripVerticalIcon");
    const _component_draggable = _resolveComponent("draggable");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_SearchIcon, {
                                    size: 18,
                                    class: "search-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.searchQuery) = $event)),
                                    placeholder: "Buscar por código...",
                                    class: "search-input"
                                }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, $setup.searchQuery]
                                ])
                            ])
                        ]),
                        _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => ($setup.openExportModal && $setup.openExportModal(...args))),
                            class: "btn btn-export-premium"
                        }, [
                            _createVNode(_component_FileTextIcon, { size: 18 }),
                            _hoisted_9
                        ]),
                        _createCommentVNode(" <button @click=\"openModal()\" class=\"btn btn-add\" v-if=\"hasPermission('REPUESTO_CREATE')\">\n                            <PlusIcon :size=\"18\" />\n                            <span>Nuevo Equivalente</span>\n                        </button> ")
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createCommentVNode(" <div class=\"filter-type-selector\">\n                            <button @click=\"filterType = 'repuestos'\" :class=\"{ active: filterType === 'repuestos' }\"\n                                class=\"filter-type-btn\">\n                                <span>Repuestos</span>\n                            </button>\n                            <button @click=\"filterType = 'modelos'\" :class=\"{ active: filterType === 'modelos' }\"\n                                class=\"filter-type-btn\">\n                                <span>Modelos</span>\n                            </button>\n                            <button @click=\"filterType = 'ambos'\" :class=\"{ active: filterType === 'ambos' }\"\n                                class=\"filter-type-btn\">\n                                <span>Ambos</span>\n                            </button>\n                        </div> "),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => ($setup.resetFilter && $setup.resetFilter(...args))),
                                class: _normalizeClass([{ active: !$setup.selectedLetter }, "alphabet-button all-button"])
                            }, " Todos ", 2 /* CLASS */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.alphabet, (letter) => {
                                return (_openBlock(), _createElementBlock("button", {
                                    key: letter,
                                    onClick: ($event) => ($setup.filterByLetter(letter)),
                                    class: _normalizeClass([{ active: $setup.selectedLetter === letter }, "alphabet-button"])
                                }, _toDisplayString(letter), 11 /* TEXT, CLASS, PROPS */, _hoisted_12));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _createCommentVNode(" Searchable Filters "),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_LayersIcon, {
                                    size: 16,
                                    class: "filter-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.searchFilterDep) = $event)),
                                    onFocus: _cache[4] || (_cache[4] = ($event) => ($setup.showFilterDeps = true)),
                                    onBlur: _cache[5] || (_cache[5] =
                                        //@ts-ignore
                                        (...args) => ($setup.onBlurFilterDep && $setup.onBlurFilterDep(...args))),
                                    placeholder: "Departamento...",
                                    class: "filter-input"
                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                    [_vModelText, $setup.searchFilterDep]
                                ]),
                                ($setup.showFilterDeps && $setup.filteredFilterDepsList.length)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                                        _createElementVNode("li", {
                                            onMousedown: _cache[6] || (_cache[6] =
                                                //@ts-ignore
                                                (...args) => ($setup.clearFilterDep && $setup.clearFilterDep(...args))),
                                            class: "clear-option"
                                        }, _hoisted_17, 32 /* NEED_HYDRATION */),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredFilterDepsList, (dep) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: dep.departamentoID,
                                                onMousedown: ($event) => ($setup.selectFilterDep(dep)),
                                                innerHTML: dep.highlightedNombre
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_18));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", {
                                class: _normalizeClass(["filter-group autocomplete", { disabled: !$setup.filterDepartamentoId }])
                            }, [
                                _createVNode(_component_GridIcon, {
                                    size: 16,
                                    class: "filter-icon"
                                }),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (($setup.searchFilterCat) = $event)),
                                    onFocus: _cache[8] || (_cache[8] = ($event) => ($setup.showFilterCats = true)),
                                    onBlur: _cache[9] || (_cache[9] =
                                        //@ts-ignore
                                        (...args) => ($setup.onBlurFilterCat && $setup.onBlurFilterCat(...args))),
                                    placeholder: "Categoría...",
                                    class: "filter-input",
                                    disabled: !$setup.filterDepartamentoId
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_19), [
                                    [_vModelText, $setup.searchFilterCat]
                                ]),
                                ($setup.showFilterCats && $setup.filteredFilterCatsList.length)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                                        _createElementVNode("li", {
                                            onMousedown: _cache[10] || (_cache[10] =
                                                //@ts-ignore
                                                (...args) => ($setup.clearFilterCat && $setup.clearFilterCat(...args))),
                                            class: "clear-option"
                                        }, _hoisted_22, 32 /* NEED_HYDRATION */),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredFilterCatsList, (cat) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: cat.categoriaID,
                                                onMousedown: ($event) => ($setup.selectFilterCat(cat)),
                                                innerHTML: cat.highlightedNombre
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_23));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ], 2 /* CLASS */)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("table", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("tbody", null, [
                            ($setup.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_27, _hoisted_29))
                                : ($setup.paginatedEquivalentes.length === 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_30, _hoisted_32))
                                    : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedEquivalentes, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: item.isReplica ? 'rep-' + item.id : 'orig-' + item.id,
                                    class: _normalizeClass(['table-grouped-row', item.groupIndex % 2 === 0 ? 'bg-group-even' : 'bg-group-odd', { 'group-start': !item.isReplica }])
                                }, [
                                    _createElementVNode("td", _hoisted_33, [
                                        _createElementVNode("div", _hoisted_34, [
                                            _createElementVNode("span", {
                                                class: "group-item-name",
                                                style: _normalizeStyle({ opacity: item.isReplica ? '0.85' : '1', fontWeight: item.isReplica ? '500' : '700', fontSize: item.isReplica ? '0.9rem' : '0.95rem' })
                                            }, _toDisplayString(item.nombreRepuesto || $setup.getRepuestoNombre(item.repuestoId)), 5 /* TEXT, STYLE */)
                                        ])
                                    ]),
                                    _createElementVNode("td", _hoisted_35, [
                                        _createElementVNode("div", _hoisted_36, [
                                            _createElementVNode("span", {
                                                class: "attribute-badge",
                                                style: _normalizeStyle({ backgroundColor: item.isReplica ? '#f3f4f6' : '#eff6ff', color: item.isReplica ? '#4b5563' : '#3b82f6', border: item.isReplica ? '1px solid #e5e7eb' : 'none' })
                                            }, _toDisplayString(item.codigoEquivalente || 'N/A'), 5 /* TEXT, STYLE */)
                                        ])
                                    ]),
                                    _createElementVNode("td", {
                                        class: "text-center stock-cell",
                                        style: _normalizeStyle({ opacity: item.isReplica ? '0.8' : '1' })
                                    }, [
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("button", {
                                                class: "step-btn",
                                                onClick: _withModifiers(($event) => ($setup.updateStock(item, 'expless', item.expless - 1)), ["stop"]),
                                                disabled: $setup.stockSaving,
                                                title: "-1"
                                            }, [
                                                _createVNode(_component_ChevronDownIcon, { size: 13 })
                                            ], 8 /* PROPS */, _hoisted_38),
                                            _createElementVNode("input", {
                                                type: "number",
                                                value: item.expless,
                                                min: "0",
                                                class: "stepper-input",
                                                onChange: ($event) => ($setup.updateStock(item, 'expless', +$event.target.value)),
                                                onKeyup: _cache[11] || (_cache[11] = _withKeys(($event) => ($event.target.blur()), ["enter"]))
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_39),
                                            _createElementVNode("button", {
                                                class: "step-btn",
                                                onClick: _withModifiers(($event) => ($setup.updateStock(item, 'expless', item.expless + 1)), ["stop"]),
                                                disabled: $setup.stockSaving,
                                                title: "+1"
                                            }, [
                                                _createVNode(_component_ChevronUpIcon, { size: 13 })
                                            ], 8 /* PROPS */, _hoisted_40)
                                        ])
                                    ], 4 /* STYLE */),
                                    _createElementVNode("td", {
                                        class: "text-center stock-cell",
                                        style: _normalizeStyle({ opacity: item.isReplica ? '0.8' : '1' })
                                    }, [
                                        _createElementVNode("div", _hoisted_41, [
                                            _createElementVNode("button", {
                                                class: "step-btn",
                                                onClick: _withModifiers(($event) => ($setup.updateStock(item, 'plus', item.plus - 1)), ["stop"]),
                                                disabled: $setup.stockSaving,
                                                title: "-1"
                                            }, [
                                                _createVNode(_component_ChevronDownIcon, { size: 13 })
                                            ], 8 /* PROPS */, _hoisted_42),
                                            _createElementVNode("input", {
                                                type: "number",
                                                value: item.plus,
                                                min: "0",
                                                class: "stepper-input",
                                                onChange: ($event) => ($setup.updateStock(item, 'plus', +$event.target.value)),
                                                onKeyup: _cache[12] || (_cache[12] = _withKeys(($event) => ($event.target.blur()), ["enter"]))
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_43),
                                            _createElementVNode("button", {
                                                class: "step-btn",
                                                onClick: _withModifiers(($event) => ($setup.updateStock(item, 'plus', item.plus + 1)), ["stop"]),
                                                disabled: $setup.stockSaving,
                                                title: "+1"
                                            }, [
                                                _createVNode(_component_ChevronUpIcon, { size: 13 })
                                            ], 8 /* PROPS */, _hoisted_44)
                                        ])
                                    ], 4 /* STYLE */),
                                    _createElementVNode("td", {
                                        class: "text-center stock-cell",
                                        style: _normalizeStyle({ opacity: item.isReplica ? '0.8' : '1' })
                                    }, [
                                        _createElementVNode("div", _hoisted_45, [
                                            _createElementVNode("button", {
                                                class: "step-btn",
                                                onClick: _withModifiers(($event) => ($setup.updateStock(item, 'mega', item.mega - 1)), ["stop"]),
                                                disabled: $setup.stockSaving,
                                                title: "-1"
                                            }, [
                                                _createVNode(_component_ChevronDownIcon, { size: 13 })
                                            ], 8 /* PROPS */, _hoisted_46),
                                            _createElementVNode("input", {
                                                type: "number",
                                                value: item.mega,
                                                min: "0",
                                                class: "stepper-input",
                                                onChange: ($event) => ($setup.updateStock(item, 'mega', +$event.target.value)),
                                                onKeyup: _cache[13] || (_cache[13] = _withKeys(($event) => ($event.target.blur()), ["enter"]))
                                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_47),
                                            _createElementVNode("button", {
                                                class: "step-btn",
                                                onClick: _withModifiers(($event) => ($setup.updateStock(item, 'mega', item.mega + 1)), ["stop"]),
                                                disabled: $setup.stockSaving,
                                                title: "+1"
                                            }, [
                                                _createVNode(_component_ChevronUpIcon, { size: 13 })
                                            ], 8 /* PROPS */, _hoisted_48)
                                        ])
                                    ], 4 /* STYLE */),
                                    _createElementVNode("td", {
                                        class: "text-center fw-bold",
                                        style: _normalizeStyle({ opacity: item.isReplica ? '0.8' : '1', color: '#1d4ed8' })
                                    }, _toDisplayString((item.expless || 0) + (item.plus || 0) + (item.mega || 0)), 5 /* TEXT, STYLE */),
                                    _createElementVNode("td", _hoisted_49, [
                                        _createElementVNode("div", _hoisted_50, [
                                            (item.multiMedia && item.multiMedia.length > 0)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    onClick: ($event) => ($setup.openLightbox(item)),
                                                    class: "btn-icon btn-gallery",
                                                    title: "Ver imágenes"
                                                }, [
                                                    _createElementVNode("div", _hoisted_52, [
                                                        _createVNode(_component_ImageIcon, { size: 20 }),
                                                        ($setup.getMediaCount(item, 'Imagen') > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString($setup.getMediaCount(item, 'Imagen')), 1 /* TEXT */))
                                                            : _createCommentVNode("v-if", true),
                                                        ($setup.getMediaCount(item, 'Video') > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString($setup.getMediaCount(item, 'Video')), 1 /* TEXT */))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ], 8 /* PROPS */, _hoisted_51))
                                                : _createCommentVNode("v-if", true),
                                            ($setup.can($setup.P.EQUIVALENTES.EDIT) && !item.isReplica)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    onClick: ($event) => ($setup.openModal(item)),
                                                    class: "btn-icon btn-edit",
                                                    title: "Editar"
                                                }, [
                                                    _createVNode(_component_EditIcon, { size: 18 })
                                                ], 8 /* PROPS */, _hoisted_55))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ], 2 /* CLASS */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("button", {
                        onClick: _cache[14] || (_cache[14] =
                            //@ts-ignore
                            (...args) => ($setup.prevPage && $setup.prevPage(...args))),
                        disabled: $setup.currentPage === 1,
                        class: "btn-pagination"
                    }, [
                        _createVNode(_component_ChevronLeftIcon, { size: 16 }),
                        _createTextVNode(" Anterior ")
                    ], 8 /* PROPS */, _hoisted_57),
                    _createElementVNode("span", null, [
                        _createTextVNode("Página "),
                        _createElementVNode("strong", null, _toDisplayString($setup.currentPage), 1 /* TEXT */),
                        _createTextVNode(" de "),
                        _createElementVNode("strong", null, _toDisplayString($setup.totalPages), 1 /* TEXT */)
                    ]),
                    _createElementVNode("button", {
                        onClick: _cache[15] || (_cache[15] =
                            //@ts-ignore
                            (...args) => ($setup.nextPage && $setup.nextPage(...args))),
                        disabled: $setup.currentPage === $setup.totalPages,
                        class: "btn-pagination"
                    }, [
                        _createTextVNode(" Siguiente "),
                        _createVNode(_component_ChevronRightIcon, { size: 16 })
                    ], 8 /* PROPS */, _hoisted_58)
                ]),
                _createElementVNode("div", _hoisted_59, " Total Equivalentes Registrados: " + _toDisplayString($setup.totalCount), 1 /* TEXT */),
                _createCommentVNode(" Lightbox Carousel "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isLightboxOpen)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "lightbox-overlay",
                                onClick: _cache[21] || (_cache[21] = _withModifiers(
                                //@ts-ignore
                                (...args) => ($setup.closeLightbox && $setup.closeLightbox(...args)), ["self"]))
                            }, [
                                _createElementVNode("div", _hoisted_60, [
                                    _createElementVNode("button", {
                                        class: "lightbox-close",
                                        onClick: _cache[16] || (_cache[16] =
                                            //@ts-ignore
                                            (...args) => ($setup.closeLightbox && $setup.closeLightbox(...args)))
                                    }, [
                                        _createVNode(_component_XIcon, { size: 24 })
                                    ]),
                                    _createElementVNode("div", _hoisted_61, [
                                        ($setup.filteredLightboxItems[$setup.lightboxIndex])
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                ($setup.filteredLightboxItems[$setup.lightboxIndex].tipo === 'Imagen')
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: $setup.filteredLightboxItems[$setup.lightboxIndex].url,
                                                        class: "lightbox-media",
                                                        alt: "Imagen"
                                                    }, null, 8 /* PROPS */, _hoisted_62))
                                                    : (_openBlock(), _createElementBlock("video", {
                                                        key: 1,
                                                        src: $setup.filteredLightboxItems[$setup.lightboxIndex].url,
                                                        class: "lightbox-media",
                                                        controls: "",
                                                        autoplay: ""
                                                    }, null, 8 /* PROPS */, _hoisted_63))
                                            ], 64 /* STABLE_FRAGMENT */))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                _createElementVNode("span", null, "Sin " + _toDisplayString($setup.lightboxFilter === 'Imagen' ? 'imágenes' : 'videos'), 1 /* TEXT */)
                                            ]))
                                    ]),
                                    ($setup.filteredLightboxItems.length > 1)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "lightbox-nav lightbox-prev",
                                            onClick: _cache[17] || (_cache[17] =
                                                //@ts-ignore
                                                (...args) => ($setup.lightboxPrev && $setup.lightboxPrev(...args)))
                                        }, [
                                            _createVNode(_component_ChevronLeftIcon, { size: 28 })
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    ($setup.filteredLightboxItems.length > 1)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "lightbox-nav lightbox-next",
                                            onClick: _cache[18] || (_cache[18] =
                                                //@ts-ignore
                                                (...args) => ($setup.lightboxNext && $setup.lightboxNext(...args)))
                                        }, [
                                            _createVNode(_component_ChevronRightIcon, { size: 28 })
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" Type filter tabs "),
                                    _createElementVNode("div", _hoisted_65, [
                                        ($setup.lightboxItems.some(i => i.tipo === 'Imagen'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: _normalizeClass(["lightbox-tab", { active: $setup.lightboxFilter === 'Imagen' }]),
                                                onClick: _cache[19] || (_cache[19] = ($event) => ($setup.setLightboxFilter('Imagen')))
                                            }, [
                                                _createVNode(_component_ImageIcon, { size: 14 }),
                                                _createTextVNode(" Imágenes "),
                                                _createElementVNode("span", _hoisted_66, _toDisplayString($setup.lightboxItems.filter(i => i.tipo === 'Imagen').length), 1 /* TEXT */)
                                            ], 2 /* CLASS */))
                                            : _createCommentVNode("v-if", true),
                                        ($setup.lightboxItems.some(i => i.tipo === 'Video'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                class: _normalizeClass(["lightbox-tab", { active: $setup.lightboxFilter === 'Video' }]),
                                                onClick: _cache[20] || (_cache[20] = ($event) => ($setup.setLightboxFilter('Video')))
                                            }, [
                                                _createVNode(_component_VideoIcon, { size: 14 }),
                                                _createTextVNode(" Videos "),
                                                _createElementVNode("span", _hoisted_67, _toDisplayString($setup.lightboxItems.filter(i => i.tipo === 'Video').length), 1 /* TEXT */)
                                            ], 2 /* CLASS */))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    ($setup.filteredLightboxItems.length > 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredLightboxItems, (_, i) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                    key: i,
                                                    class: _normalizeClass(["lightbox-dot", { active: i === $setup.lightboxIndex }]),
                                                    onClick: ($event) => ($setup.lightboxIndex = i)
                                                }, null, 10 /* CLASS, PROPS */, _hoisted_69));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    ($setup.filteredLightboxItems.length > 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString($setup.lightboxIndex + 1) + " / " + _toDisplayString($setup.filteredLightboxItems.length), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isModalOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("div", _hoisted_73, [
                                        _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("div", _hoisted_75, [
                                                (!$setup.isEditing)
                                                    ? (_openBlock(), _createBlock(_component_PlusIcon, {
                                                        key: 0,
                                                        size: 24,
                                                        class: "text-primary"
                                                    }))
                                                    : (_openBlock(), _createBlock(_component_EditIcon, {
                                                        key: 1,
                                                        size: 24,
                                                        class: "text-primary"
                                                    }))
                                            ]),
                                            _createElementVNode("h2", _hoisted_76, _toDisplayString($setup.isEditing ? 'Editar Equivalente' : 'Nuevo Equivalente'), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[22] || (_cache[22] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("form", {
                                        onSubmit: _cache[32] || (_cache[32] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => ($setup.saveEquivalente && $setup.saveEquivalente(...args)), ["prevent"])),
                                        class: "modal-body"
                                    }, [
                                        _createElementVNode("div", _hoisted_77, [
                                            _createElementVNode("label", null, [
                                                _createTextVNode(" Repuesto "),
                                                ($setup.isEditing)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_78, " Cod: " + _toDisplayString($setup.baseCode), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_79, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => (($setup.searchRepuestoText) = $event)),
                                                    onInput: _cache[24] || (_cache[24] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.onSearchRepuesto && $setup.onSearchRepuesto(...args))),
                                                    disabled: $setup.isEditing,
                                                    placeholder: "Buscar y seleccionar repuesto...",
                                                    class: _normalizeClass(['form-control', 'no-icon', $setup.isEditing ? 'disabled-input' : ''])
                                                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_80), [
                                                    [_vModelText, $setup.searchRepuestoText]
                                                ]),
                                                ($setup.filteredRepuestosForSelect.length > 0 && $setup.searchRepuestoText.length >= 3 && $setup.showRepuestoDropdown)
                                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_81, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredRepuestosForSelect, (repuesto) => {
                                                            return (_openBlock(), _createElementBlock("li", {
                                                                key: repuesto.repuestoID,
                                                                onClick: ($event) => ($setup.selectRepuesto(repuesto)),
                                                                innerHTML: repuesto.highlightedNombre
                                                            }, null, 8 /* PROPS */, _hoisted_82));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_83, [
                                            _hoisted_84,
                                            _createElementVNode("div", _hoisted_85, [
                                                _createCommentVNode(" Header Labels (Desktop only) "),
                                                _hoisted_86,
                                                _createElementVNode("div", _hoisted_87, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.items, (item, index) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: index,
                                                            class: _normalizeClass(["compact-bulk-row", { 'is-replica': item.esReplica }])
                                                        }, [
                                                            _createElementVNode("div", _hoisted_88, [
                                                                _createCommentVNode(" Código "),
                                                                _createElementVNode("div", _hoisted_89, [
                                                                    _createElementVNode("div", _hoisted_90, [
                                                                        _hoisted_91,
                                                                        _withDirectives(_createElementVNode("input", {
                                                                            "onUpdate:modelValue": ($event) => ((item.codigoEquivalente) = $event),
                                                                            placeholder: "EQXXXX",
                                                                            readonly: "",
                                                                            class: "form-control compact-input disabled-input"
                                                                        }, null, 8 /* PROPS */, _hoisted_92), [
                                                                            [_vModelText, item.codigoEquivalente]
                                                                        ])
                                                                    ])
                                                                ]),
                                                                _createCommentVNode(" Stock Exp "),
                                                                _createElementVNode("div", _hoisted_93, [
                                                                    _createElementVNode("div", _hoisted_94, [
                                                                        _hoisted_95,
                                                                        _withDirectives(_createElementVNode("input", {
                                                                            type: "number",
                                                                            "onUpdate:modelValue": ($event) => ((item.expless) = $event),
                                                                            required: "",
                                                                            class: "form-control compact-input text-center"
                                                                        }, null, 8 /* PROPS */, _hoisted_96), [
                                                                            [
                                                                                _vModelText,
                                                                                item.expless,
                                                                                void 0,
                                                                                { number: true }
                                                                            ]
                                                                        ])
                                                                    ])
                                                                ]),
                                                                _createCommentVNode(" Stock Plus "),
                                                                _createElementVNode("div", _hoisted_97, [
                                                                    _createElementVNode("div", _hoisted_98, [
                                                                        _hoisted_99,
                                                                        _withDirectives(_createElementVNode("input", {
                                                                            type: "number",
                                                                            "onUpdate:modelValue": ($event) => ((item.plus) = $event),
                                                                            required: "",
                                                                            class: "form-control compact-input text-center"
                                                                        }, null, 8 /* PROPS */, _hoisted_100), [
                                                                            [
                                                                                _vModelText,
                                                                                item.plus,
                                                                                void 0,
                                                                                { number: true }
                                                                            ]
                                                                        ])
                                                                    ])
                                                                ]),
                                                                _createCommentVNode(" Stock Mega "),
                                                                _createElementVNode("div", _hoisted_101, [
                                                                    _createElementVNode("div", _hoisted_102, [
                                                                        _hoisted_103,
                                                                        _withDirectives(_createElementVNode("input", {
                                                                            type: "number",
                                                                            "onUpdate:modelValue": ($event) => ((item.mega) = $event),
                                                                            required: "",
                                                                            class: "form-control compact-input text-center"
                                                                        }, null, 8 /* PROPS */, _hoisted_104), [
                                                                            [
                                                                                _vModelText,
                                                                                item.mega,
                                                                                void 0,
                                                                                { number: true }
                                                                            ]
                                                                        ])
                                                                    ])
                                                                ]),
                                                                _createCommentVNode(" Total (Desktop only) "),
                                                                _createElementVNode("div", _hoisted_105, [
                                                                    _createElementVNode("div", _hoisted_106, [
                                                                        _createElementVNode("input", {
                                                                            type: "number",
                                                                            value: Number(item.expless || 0) + Number(item.plus || 0) + Number(item.mega || 0),
                                                                            readonly: "",
                                                                            class: "form-control compact-input total-input text-center"
                                                                        }, null, 8 /* PROPS */, _hoisted_107)
                                                                    ])
                                                                ]),
                                                                _createCommentVNode(" Acciones "),
                                                                _hoisted_108
                                                            ])
                                                        ], 2 /* CLASS */));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ])
                                            ])
                                        ]),
                                        _createCommentVNode(" Single item edit removed "),
                                        _createCommentVNode(" Media section visible only for editing "),
                                        ($setup.isEditing && !$setup.form.isReplica)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                                _createElementVNode("div", _hoisted_110, [
                                                    _hoisted_111,
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        onClick: _cache[25] || (_cache[25] = ($event) => ($setup.removeGreen = !$setup.removeGreen)),
                                                        class: _normalizeClass(['btn-magic-remove', { active: $setup.removeGreen }]),
                                                        title: "Quitar fondo verde automáticamente"
                                                    }, [
                                                        _createVNode(_component_Wand2Icon, { size: 16 }),
                                                        _createElementVNode("span", null, _toDisplayString($setup.removeGreen ? 'Auto-recorte activado' : 'Quitar fondo verde'), 1 /* TEXT */)
                                                    ], 2 /* CLASS */)
                                                ]),
                                                _createElementVNode("div", _hoisted_112, [
                                                    _createCommentVNode(" Fotos "),
                                                    _createElementVNode("div", _hoisted_113, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.imagePreviews, (img, idx) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: idx,
                                                                class: "media-preview"
                                                            }, [
                                                                _createElementVNode("img", {
                                                                    src: img.url,
                                                                    alt: "Preview"
                                                                }, null, 8 /* PROPS */, _hoisted_114),
                                                                _createElementVNode("button", {
                                                                    type: "button",
                                                                    onClick: ($event) => ($setup.removeImage(idx)),
                                                                    class: "btn-remove-media"
                                                                }, [
                                                                    _createVNode(_component_XIcon, { size: 14 })
                                                                ], 8 /* PROPS */, _hoisted_115)
                                                            ]));
                                                        }), 128 /* KEYED_FRAGMENT */)),
                                                        _createCommentVNode(" Galería fotos "),
                                                        ($setup.imagePreviews.length < 6)
                                                            ? (_openBlock(), _createElementBlock("label", _hoisted_116, [
                                                                _createElementVNode("input", {
                                                                    type: "file",
                                                                    onChange: _cache[26] || (_cache[26] =
                                                                        //@ts-ignore
                                                                        (...args) => ($setup.handleImageUpload && $setup.handleImageUpload(...args))),
                                                                    accept: "image/*",
                                                                    multiple: "",
                                                                    capture: "environment",
                                                                    hidden: ""
                                                                }, null, 32 /* NEED_HYDRATION */),
                                                                _createVNode(_component_ImageIcon, { size: 22 }),
                                                                _hoisted_117
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createCommentVNode(" Cámara fotos "),
                                                        ($setup.imagePreviews.length < 6)
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 1,
                                                                type: "button",
                                                                class: "media-add camera-add",
                                                                title: "Tomar foto",
                                                                onClick: _cache[27] || (_cache[27] = ($event) => ($setup.openCamera('photo')))
                                                            }, [
                                                                _createVNode(_component_CameraIcon, { size: 22 }),
                                                                _hoisted_118
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ]),
                                                    _createCommentVNode(" Video "),
                                                    _createElementVNode("div", _hoisted_119, [
                                                        ($setup.videoPreview)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                                                _createElementVNode("video", {
                                                                    src: $setup.videoPreview,
                                                                    controls: ""
                                                                }, null, 8 /* PROPS */, _hoisted_121),
                                                                _createElementVNode("button", {
                                                                    type: "button",
                                                                    onClick: _cache[28] || (_cache[28] =
                                                                        //@ts-ignore
                                                                        (...args) => ($setup.removeVideo && $setup.removeVideo(...args))),
                                                                    class: "btn-remove-media"
                                                                }, [
                                                                    _createVNode(_component_XIcon, { size: 14 })
                                                                ])
                                                            ]))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createCommentVNode(" Galería video "),
                                                                _createElementVNode("label", _hoisted_122, [
                                                                    _createElementVNode("input", {
                                                                        type: "file",
                                                                        onChange: _cache[29] || (_cache[29] =
                                                                            //@ts-ignore
                                                                            (...args) => ($setup.handleVideoUpload && $setup.handleVideoUpload(...args))),
                                                                        accept: "video/*",
                                                                        capture: "environment",
                                                                        hidden: ""
                                                                    }, null, 32 /* NEED_HYDRATION */),
                                                                    _createVNode(_component_VideoIcon, { size: 22 }),
                                                                    _hoisted_123
                                                                ]),
                                                                _createCommentVNode(" Cámara video "),
                                                                _createElementVNode("button", {
                                                                    type: "button",
                                                                    class: "media-add camera-add",
                                                                    title: "Grabar video",
                                                                    onClick: _cache[30] || (_cache[30] = ($event) => ($setup.openCamera('video')))
                                                                }, [
                                                                    _createVNode(_component_CameraIcon, { size: 22 }),
                                                                    _hoisted_124
                                                                ])
                                                            ], 64 /* STABLE_FRAGMENT */))
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_125, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[31] || (_cache[31] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                                class: "btn-cancel-modal"
                                            }, "Cancelar"),
                                            _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn-save-modal",
                                                disabled: $setup.isSubmitting
                                            }, _toDisplayString($setup.isSubmitting ? 'Guardando...' : ($setup.isEditing ? 'Actualizar' : 'Registrar')), 9 /* TEXT, PROPS */, _hoisted_126)
                                        ])
                                    ], 32 /* NEED_HYDRATION */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createCommentVNode(" Overlay de Procesamiento IA "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isProcessingIA)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                _createElementVNode("div", _hoisted_128, [
                                    _createVNode(_component_Loader2Icon, {
                                        class: "ia-spinner",
                                        size: 48
                                    }),
                                    _hoisted_129,
                                    _hoisted_130
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createCommentVNode(" ======= MODAL CÁMARA ======= "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.cameraOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                _createElementVNode("div", _hoisted_132, [
                                    _createElementVNode("div", _hoisted_133, [
                                        _createElementVNode("span", _hoisted_134, _toDisplayString($setup.cameraMode === 'photo' ? 'Tomar Foto' : 'Grabar Video'), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_135, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[33] || (_cache[33] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.switchCamera && $setup.switchCamera(...args))),
                                                class: "btn-flip-camera",
                                                title: "Cambiar cámara"
                                            }, [
                                                _createVNode(_component_RepeatIcon, { size: 20 })
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[34] || (_cache[34] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.closeCamera && $setup.closeCamera(...args))),
                                                class: "btn-close-modal"
                                            }, [
                                                _createVNode(_component_XIcon, { size: 20 })
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_136, [
                                        _createElementVNode("video", _hoisted_137, null, 512 /* NEED_PATCH */),
                                        _createElementVNode("canvas", _hoisted_138, null, 512 /* NEED_PATCH */),
                                        _createCommentVNode(" Indicador REC "),
                                        ($setup.isRecording)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                                _hoisted_140,
                                                _createTextVNode(" REC ")
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_141, [
                                        _createCommentVNode(" Foto "),
                                        ($setup.cameraMode === 'photo')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn-capture",
                                                    onClick: _cache[35] || (_cache[35] =
                                                        //@ts-ignore
                                                        (...args) => ($setup.capturePhoto && $setup.capturePhoto(...args)))
                                                }, [
                                                    _createVNode(_component_CameraIcon, { size: 28 }),
                                                    _createTextVNode(" Capturar ")
                                                ]),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    onClick: _cache[36] || (_cache[36] = ($event) => ($setup.removeGreen = !$setup.removeGreen)),
                                                    class: _normalizeClass(['btn-magic-remove', { active: $setup.removeGreen }]),
                                                    title: "Quitar fondo verde automáticamente",
                                                    style: { "margin-top": "4px" }
                                                }, [
                                                    _createVNode(_component_Wand2Icon, { size: 18 }),
                                                    _createElementVNode("span", null, _toDisplayString($setup.removeGreen ? 'Recorte activo' : 'Quitar fondo verde'), 1 /* TEXT */)
                                                ], 2 /* CLASS */)
                                            ]))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createCommentVNode(" Video "),
                                                (!$setup.isRecording)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        type: "button",
                                                        class: "btn-capture btn-record",
                                                        onClick: _cache[37] || (_cache[37] =
                                                            //@ts-ignore
                                                            (...args) => ($setup.startRecording && $setup.startRecording(...args)))
                                                    }, [
                                                        _hoisted_143,
                                                        _createTextVNode(" Iniciar grabación ")
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        type: "button",
                                                        class: "btn-capture btn-stop",
                                                        onClick: _cache[38] || (_cache[38] =
                                                            //@ts-ignore
                                                            (...args) => ($setup.stopRecording && $setup.stopRecording(...args)))
                                                    }, [
                                                        _hoisted_144,
                                                        _createTextVNode(" Detener ")
                                                    ]))
                                            ], 64 /* STABLE_FRAGMENT */))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createCommentVNode(" ======= MODAL EXPORTAR EXCEL PREMIUM ======= "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        ($setup.isExportModalOpen)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-overlay",
                                onClick: _cache[51] || (_cache[51] = _withModifiers(
                                //@ts-ignore
                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args)), ["self"]))
                            }, [
                                _createElementVNode("div", _hoisted_145, [
                                    _createElementVNode("div", _hoisted_146, [
                                        _createElementVNode("div", _hoisted_147, [
                                            _createElementVNode("div", _hoisted_148, [
                                                _createVNode(_component_DownloadIcon, {
                                                    size: 24,
                                                    class: "text-excel"
                                                })
                                            ]),
                                            _hoisted_149
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[39] || (_cache[39] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args))),
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_component_XIcon, { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_150, [
                                        _createElementVNode("div", _hoisted_151, [
                                            _createVNode(_component_InfoIcon, {
                                                size: 18,
                                                class: "text-primary"
                                            }),
                                            _hoisted_152
                                        ]),
                                        _createElementVNode("div", _hoisted_153, [
                                            _hoisted_154,
                                            _createElementVNode("div", _hoisted_155, [
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["export-format-card", { active: $setup.exportConfig.format === 'excel' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => (($setup.exportConfig.format) = $event)),
                                                        value: "excel",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.format]
                                                    ]),
                                                    _hoisted_156
                                                ], 2 /* CLASS */),
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["export-format-card", { active: $setup.exportConfig.format === 'pdf' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => (($setup.exportConfig.format) = $event)),
                                                        value: "pdf",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.format]
                                                    ]),
                                                    _hoisted_157
                                                ], 2 /* CLASS */)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_158, [
                                            _hoisted_159,
                                            _createElementVNode("div", _hoisted_160, [
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["filter-card", { active: $setup.exportConfig.filterType === 'originales' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event) => (($setup.exportConfig.filterType) = $event)),
                                                        value: "originales",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.filterType]
                                                    ]),
                                                    _hoisted_161
                                                ], 2 /* CLASS */),
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["filter-card", { active: $setup.exportConfig.filterType === 'replicas' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => (($setup.exportConfig.filterType) = $event)),
                                                        value: "replicas",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.filterType]
                                                    ]),
                                                    _hoisted_162
                                                ], 2 /* CLASS */),
                                                _createElementVNode("label", {
                                                    class: _normalizeClass(["filter-card", { active: $setup.exportConfig.filterType === 'ambos' }])
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "radio",
                                                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event) => (($setup.exportConfig.filterType) = $event)),
                                                        value: "ambos",
                                                        hidden: ""
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelRadio, $setup.exportConfig.filterType]
                                                    ]),
                                                    _hoisted_163
                                                ], 2 /* CLASS */)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_164, [
                                            _hoisted_165,
                                            _createElementVNode("div", _hoisted_166, [
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => (($setup.exportConfig.sortColumn) = $event)),
                                                    class: "form-control",
                                                    style: { "background-color": "#f8fafc", "border": "1px solid #e2e8f0", "border-radius": "8px", "padding": "12px", "font-size": "0.95rem", "color": "#1e293b", "outline": "none", "transition": "border-color 0.2s, box-shadow 0.2s", "cursor": "pointer" }
                                                }, _hoisted_173, 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, $setup.exportConfig.sortColumn]
                                                ]),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event) => (($setup.exportConfig.sortDirection) = $event)),
                                                    class: "form-control",
                                                    style: { "background-color": "#f8fafc", "border": "1px solid #e2e8f0", "border-radius": "8px", "padding": "12px", "font-size": "0.95rem", "color": "#1e293b", "outline": "none", "transition": "border-color 0.2s, box-shadow 0.2s", "cursor": "pointer" }
                                                }, _hoisted_176, 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, $setup.exportConfig.sortDirection]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_177, [
                                            _hoisted_178,
                                            _createElementVNode("div", _hoisted_179, [
                                                _hoisted_180,
                                                _createVNode(_component_draggable, {
                                                    modelValue: $setup.availableColumns,
                                                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => (($setup.availableColumns) = $event)),
                                                    "item-key": "name",
                                                    handle: ".drag-handle",
                                                    class: "draggable-columns-list"
                                                }, {
                                                    item: _withCtx(({ element: col, index }) => [
                                                        _createElementVNode("label", {
                                                            class: _normalizeClass(["column-checkbox-card", { active: $setup.exportConfig.selectedColumns.includes(col.name) }])
                                                        }, [
                                                            _createElementVNode("div", _hoisted_181, _toDisplayString(index + 1), 1 /* TEXT */),
                                                            _createElementVNode("div", _hoisted_182, [
                                                                _createVNode(_component_GripVerticalIcon, { size: 16 })
                                                            ]),
                                                            _createElementVNode("div", _hoisted_183, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "checkbox",
                                                                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event) => (($setup.exportConfig.selectedColumns) = $event)),
                                                                    value: col.name
                                                                }, null, 8 /* PROPS */, _hoisted_184), [
                                                                    [_vModelCheckbox, $setup.exportConfig.selectedColumns]
                                                                ]),
                                                                _hoisted_185
                                                            ]),
                                                            _createElementVNode("div", _hoisted_186, [
                                                                _createElementVNode("span", _hoisted_187, _toDisplayString(col.name), 1 /* TEXT */)
                                                            ])
                                                        ], 2 /* CLASS */)
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue"])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_188, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[49] || (_cache[49] =
                                                //@ts-ignore
                                                (...args) => ($setup.closeExportModal && $setup.closeExportModal(...args))),
                                            class: "btn-cancel-modal"
                                        }, "Cancelar"),
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[50] || (_cache[50] =
                                                //@ts-ignore
                                                (...args) => ($setup.handleExport && $setup.handleExport(...args))),
                                            class: "btn-save-modal btn-excel",
                                            disabled: $setup.isExporting
                                        }, [
                                            ($setup.isExporting)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_190, "Generando..."))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                                    _createVNode(_component_FileTextIcon, { size: 18 }),
                                                    _hoisted_192
                                                ]))
                                        ], 8 /* PROPS */, _hoisted_189)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ])
    ]));
}
